import React from "react";
import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router";
import "../../stylesheet/forms.css";
import { BsCheck } from "react-icons/bs";
import Patients from "./Forms/Patients";
import Drugs from "./Forms/Drugs";
import Instructions from "./Forms/Instructions";
import Summary from "./Forms/Summary";
import Topnav from "../others/Topnav";
import PropTypes from "prop-types";
import WStepper from "../utils/WizardStepper";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addPatientData } from "../../reducers/patientReducers";
import {
  addPriscription,
  getSelectedPriscription,
} from "../../Utils/localStore";
import ToastContext from "../../context/toasterContex";

const NewPrescription = ({ noTopnav, stage, mode, update, userDetails }) => {
  const { toast } = useContext(ToastContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const queryParams = searchParams.get("position");
  const [prescriptionCreated, setPrescriptionCreated] = useState(false);
  const [currentStage, setCurrentStage] = useState(1);
  const [formData, setFormData] = useState({
    patient: {
      name: "",
      gender: "",
      phoneNumber: "",
      email: "",
      age: "",
      pulse: "",
      weight: "",
      height: "",
      systolic: "",
      diastolic: "",
      temperature: "",
      complaints: "",
      examination: "",
      diagnosis: "",
      joinedDate: "",
      status: "Active",
    },
    drugs: [],
    instructions: {
      allowed: "",
      expiryDate: null,
      endDate: null,
    },
  });

  const addNewPrescription = () => {
    scrollToTop();
    // setCurrentStage(4);
    // Set the current stage to 4 when prescription is created
    setPrescriptionCreated(true);
    // Set prescriptionCreated to true
    localStorage.setItem("prescriptionCreated", true);
    // Store in local storage

    addPriscription(formData)
      .then((resp) => {
        toast.success("Prescription added successfully!", {
          position: toast.POSITION.TOP_CENTER,
        });
        if (mode) {
          update();
        } else {
          navigate("/prescription");
        }
      })
      .catch((error) => {
        console.error({ error });
        toast.error("Something went wrong, please contact admin", {
          position: toast.POSITION.TOP_CENTER,
        });
        throw new Error(error);
      });
  };
  const getLocalData = async () => {
    let response;
    try {
      await getSelectedPriscription().then((resp) => (response = resp[0]));
      // setFormData(response)
      const { patient, drugs, instructions } = response;
      setFormData({ patient, drugs, instructions });
    } catch (error) {
      // toast.error(error, { position: toast.POSITION.TOP_CENTER })
      throw new Error(error);
    }
  };

  const updateFormData = (newData) => {
    setFormData((prevData) => ({
      ...prevData,
      ...newData,
    }));
  };

  // const formContentRef = useRef(null);

  const scrollToTop = () => {
    // if (formContentRef.current) {
    //   formContentRef.current.scrollTo(0, 0);
    // }
  };

  useEffect(() => {
    const initializeForm = async () => {
      if (queryParams) {
        // Scenario 3: Edit or Summary mode
        try {
          await getLocalData();
          setCurrentStage(queryParams === "edit" ? 1 : 4);
        } catch (error) {
          console.error("Error fetching local data:", error);
          toast.error("Failed to load prescription data. Please try again.");
        }
      } else if (userDetails) {
        // Scenario 2: Creating new prescription for existing patient
        await getLocalData();
        setFormData((prevData) => ({
          ...prevData,
          patient: {
            ...prevData.patient,
            ...userDetails,
          },
          userLocalId: userDetails.localID,
        }));
        setCurrentStage(2);
      } else {
        // Scenario 1: Fresh prescription for new patient
        setCurrentStage(1);
      }
    };

    initializeForm();
    // if (localStorage.getItem("patientEditMode") === "true") {
    //   getLocalData();
    // }
    // const fastPosition = window.location.search.includes("summary")
    //   ? "summary"
    //   : "";
    // const editPosition = window.location.search.includes("edit") ? "edit" : "";

    // if (fastPosition) {
    //   setCurrentStage(4);
    // } else if (editPosition) {
    //   getLocalData();
    // } else {
    //   setCurrentStage(1);
    //   if (userDetails) {
    //     setFormData((prevData) => ({
    //       ...prevData,
    //       patient: {
    //         ...prevData.patient,
    //         ...userDetails,
    //       },
    //       userLocalId: userDetails.localID,
    //     }));
    //     setCurrentStage(2);
    //   } else {
    //     setCurrentStage(1);
    //   }
    // }
  }, []);

  const handleNext = () => {
    if (currentStage <= 4) {
      scrollToTop();
      setCurrentStage(currentStage + 1);
    }
    // console.log("Form data saved:", formData);
  };

  const handlePrevious = () => {
    if (currentStage > 1) {
      scrollToTop();
      setCurrentStage(currentStage - 1);
    }
  };

  const handleRestartForm = () => {
    setPrescriptionCreated(false);
    localStorage.removeItem("prescriptionCreated");
  };

  return (
    <div className="new">
      {!noTopnav && <Topnav />}

      <div className={`w-full ${!mode ? 'lg:w-90 lg:px-8' : 'p-4'}` }>
        {!mode && (
          <div className="w-full flex items-center justify-center my-6">
            <WStepper
              currentTab={currentStage}
              config={[
                {
                  name: "Patient details",
                  status: "",
                },
                {
                  name: "drug details",
                  status: "Completed",
                },
                {
                  name: "instructions",
                  status: "Completed",
                },
                {
                  name: "Summary",
                  status: "Completed",
                },
              ]}
            />
          </div>
        )}

        <div
          className={` ${
            (currentStage === 4 )
              ? "w-full lg:px-10 px-4"
              : (!mode )
              ? "w-full lg:flex justify-center py-4"
              : "w-full"
  
          }`}
        >
          <form
            id="new_prescr"
          >
            <div  className={` ${
              currentStage == 4 
              ? "w-full lg:w-8/10" 
              : !mode 
              ? "w-full lg:w-[800px]"
              : "w-full"
            }`}>
              {currentStage === 1 && (
                <div className={`${!mode && 'border p-3 rounded-md'}`}>
                  <h1 className={'font-bold text-2xl'}>Patient Details</h1>
                  <Patients
                  className="steps"
                    formData={formData.patient}
                    updateFormData={updateFormData}
                    mode={mode}
                  />
                  <div className="form_btn">
                    <button type="button" onClick={handleNext}>
                      Continue
                    </button>
                  </div>
                </div>
              )}
              {currentStage === 2 && (
                <div className={`${!mode && 'border p-3 rounded-md'}`}>
                  <h1 className={'font-bold text-2xl'}>Drug Details</h1>
                  <Drugs
                  className="steps"
                    formData={formData.drugs}
                    mode={mode}
                    updateFormData={updateFormData}
                  />
                  <div className="form_btn">
                    <button
                      type="button"
                      className="back"
                      onClick={handlePrevious}
                    >
                      Back
                    </button>
                    <button type="button" onClick={handleNext}>
                      Continue
                    </button>
                  </div>
                </div>
              )}
              {currentStage === 3 && (
                <div className={`${!mode && 'border p-3 rounded-md'}`}>
                  <h1 className={'font-bold text-2xl'}>Instructions</h1>
                  <Instructions
                  className="steps inst"
                    mode={mode}
                    formData={formData.instructions}
                    updateFormData={updateFormData}
                  />
                  <div className="form_btn">
                    <button
                      type="button"
                      className="back"
                      onClick={handlePrevious}
                    >
                      Back
                    </button>
                    <button type="button" onClick={handleNext}>
                      Continue
                    </button>
                  </div>
                </div>
              )}
              {currentStage === 4 && (
                <div className={` ${mode ? 'flex justify-center flex-col p-4 lg:p-0 gap-5' : 'flex justify-center flex-col-reverse lg:flex-row p-4 lg:p-0 gap-5' }`}>
                  <div className={` ${!mode ? 'w-full lg:w-4/6' : 'w-full'}`}>
                  <h1 className={'font-bold text-2xl'}>Summary</h1>
                    <Summary data={formData}  mode={mode}/>
                  </div>
                  <div className={` ${!mode ? 'w-full lg:w-1/6 lg:mt-3' : 'w-full'}`}>
                    <div 
                      className={` ${!mode ? 'lg:ml-10 relative exception btn' : 'btn relative exception'}`}
                    >
                      <div className="relative">
                        <div>
                          <button
                            type="button"
                            className="back p-3 w-full"
                            onClick={handlePrevious}
                          >
                            Edit
                          </button>
                        </div>
                      </div>
                      <button
                        className="mt-4 w-full bg-[#009fe3] text-white rounded-md p-3"
                        type="button"
                        onClick={() => addNewPrescription()}
                      >
                        Create Prescription
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
NewPrescription.propTypes = {
  noTopnav: PropTypes.bool,
  stage: PropTypes.number,
  mode: PropTypes.string,
  update: PropTypes.func,
  userDetails: PropTypes.object,
};
export default NewPrescription;
